<template>
  <!-- 按律所找律师 -->
  <div class="lawyeroffice">
    <div class="w12 between">
      <div class="left">
        <lawoffswiper />
        <lawoffLocfir class="leftcom mt30" />
      </div>
      <div class="right">
        <lawofffastlaw class="comcol" />
        <lawoffotherfind class="comcol mt30" />
        <lawofflatestin class="comcol mt30" />
        <lawofflatserve class="comcol mt30" />
      </div>
    </div>
    <div class="bw10"><lawoffsuccase /> </div>
  </div>
</template>

<script>
import lawoffswiper from "./components/lawoffswiper";
import lawofffastlaw from "./components/lawofffastlaw";
import lawoffotherfind from "./components/lawoffotherfind";
import lawoffLocfir from "./child/lawoffLocfir";
import lawofflatestin from "./components/lawofflatestin";
import lawofflatserve from "./components/lawofflatserve";
import lawoffsuccase from "./child/lawoffsuccase";

export default {
  components: {
    lawoffswiper,
    lawofffastlaw,
    lawoffotherfind,
    lawoffLocfir,
    lawofflatestin,
    lawofflatserve,
    lawoffsuccase,
  },
};
</script>

<style lang="scss" scoped>
.lawyeroffice {
  background: #f8f8f8;
  .w12 {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    align-items: flex-start;
  
  .left {
    width: 856px;
    .leftcom {
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      border-radius: 2px;
    }
  }
  .right {
    width: 314px;
    .comcol {
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    }
  }
  }
  .bw10{
    width: 100%;
    background-color: #fff;
  }
}
</style>